export default __webpack_public_path__ + "static/media/aspera.3747598c.svg";